module.exports = window.wp.date;